import { render } from "./HomeThreePage.vue?vue&type=template&id=35ba5e11"
import script from "./HomeThreePage.vue?vue&type=script&lang=js"
export * from "./HomeThreePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__